import languageNames from './languagenames';

const synth = window.speechSynthesis || {};
let timerID = null;

const cancelSpeak = () => {
  if (timerID !== null) {
    window.clearTimeout(timerID);
    synth.cancel();
  }
};

const speak = (text, lang, voice, isAndroid, onstart = null, onend = null, onerror = null, rate = 1.0) => {
  console.log('speaking');
  console.log(lang);
  console.log(voice);
  console.log(rate);
  cancelSpeak();

  // If the sentence is too long (200-300 characters with rate of 1),
  // Chrome speechSynthesis just freezes and doesn't trigger the onend
  // event. This timeout is a safeguard against that - a better solution
  // would be to prevent long sentences in the first place.
  timerID = window.setTimeout(() => {
    if (window.speechSynthesis.speaking) {
      cancelSpeak();
      return;
    }
  }, 30000);

  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = lang;

  utterance.onstart = onstart;
  utterance.onend = onend;
  utterance.onerror = onerror;

  // utterance.onboundary = () => { console.log('TTS - onboundary event.'); };
  // utterance.onmark = () => { console.log('TTS - onmark event.'); };
  // utterance.onpause = () => { console.log('TTS - onpause event.'); };
  // utterance.onresume = () => { console.log('TTS - onresume event.'); };

  utterance.voice = voice.voice;
  utterance.rate = rate;
  synth.speak(utterance);
};

const Speak = {
  speak,
  cancel: cancelSpeak,
};

const addVoices = (voices) => {
  const newVoices = [...voices];

  const indianEnglish = newVoices.filter(voice => voice.lang === 'en-IN');
  const hindi = newVoices.filter(voice => voice.lang === 'hi-IN');

  if (hindi.length === 1 && indianEnglish.length === 0) {
    const fakeHindi = {
      lang: 'en-IN',
      ttsLang: 'hi-IN',
      languageName: 'English (Indian)',
      voice: hindi[0].voice,
    };

    newVoices.push(fakeHindi);
  }

  return newVoices;
};


/* The list of SpeechSynthesisVoices returned by SpeechSynthesis needs
to be cleaned up for the user interface (and for localization in the future).
* First, it might include a native voice without a language that we don't
* want to display.
* Secondly, the lang attribute on SpeechSynthesisVoices is different on Android
* (and maybe on other devices too).
* We want the lang in BCP 47 format: subtag hyphen subtag, en-GB.
* Even in English we'd want to display the list of languages and voices in
* a more readable format, so adding a human
* readable language and locale next to the lang tag helps with that.
*
 */
const getVoices = () => {
  if (typeof(synth.getVoices) !== 'function') {
    return [];
  }

  const voices = synth.getVoices();
  console.log(voices);
  let uiVoices = [];

  for (const voice of voices) {
    if (voice.lang.length >= 5) {
      const lang = voice.lang.substr(0, 5)
        .replace('_', '-');
      const ttsLang = voice.lang.substr(0, 5)
        .replace('_', '-');

      const uiVoice = {
        lang,
        ttsLang,
        languageName: languageNames[lang] || lang,
        voice,
      };

      uiVoices.push(uiVoice);
    }
  }

  uiVoices = addVoices(uiVoices);

  return uiVoices;
};

const onvoiceschanged = (func) => {
  synth.onvoiceschanged = func;
};

module.exports = {
  Speak,
  getVoices,
  onvoiceschanged,
};



// WEBPACK FOOTER //
// ./src/modules/audio.js